import React from 'react';

import { Icon, IconClose } from '../../../icons';
import { hideDialog } from '../../actions';

import TitleIcon from './TitleIcon';

type Props = {
    id: string,
    appearance?: 'danger' | 'warning',
    heading: string,
    onClose: Function,
    showKeyline: boolean,
    isHeadingMultiline: boolean,
    testId: string,
    iconadd: boolean,
    iconSrc: String,
    t: Function
}

/** .........
 * A default header for custom modal-dialog components.
 * Replaces @atlaskit/modal-dialog styled Header / Title / TitleText components.
 * All visual styling is in _custom_dialog.scss — no inline styles.
 *
 * @export
 * @class ModalHeader
 * @extends {React.Component<Props>}
 */
export default class ModalHeader extends React.Component<Props> {
    static defaultProps = {
        isHeadingMultiline: true
    };

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const {
            id,
            appearance,
            heading,
            onClose,
            showKeyline,
            isHeadingMultiline,
            iconadd,
            iconSrc,
            disableCloseIcon,
            testId
        } = this.props;

        if (!heading) {
            return null;
        }

        const keylineClass = showKeyline ? ' custom-modal-header--keyline' : '';
        const multilineClass = isHeadingMultiline ? ' custom-modal-header--multiline' : '';

        return (
            <div className = { `custom-modal-header${keylineClass}${multilineClass}` }>
                {iconadd
                    ? <img
                        className = 'web-based-icon custom-modal-header__icon-img'
                        src = { iconSrc } />
                    : <div className = 'custom-modal-header__title'>
                        <TitleIcon appearance = { appearance } />
                        <div
                            className = 'custom-modal-header__title-text'
                            data-testid = { testId && `${testId}-heading` }
                            id = { id }>
                            {heading}
                        </div>
                    </div>
                }
                {!disableCloseIcon && <div
                    className = 'close-dialog custom-modal-header__close'
                    onClick = { this._onHide }>
                    <Icon
                        fillColor = { '#fff' }
                        onClick = { onClose }
                        src = { IconClose } />
                </div>}
            </div>
        );
    }


    /**
         * Dispatches a redux action to hide this dialog.
         *
         * @returns {*} The return value of {@link hideDialog}.
         */
    _onHide() {
        return APP.store.dispatch(hideDialog());
    }
}
